<div class="card" style="padding: 24px 36px 32px;">
  <div class="d-flex justify-content-end align-items-center gap-16">
    <div style="width: 40px;"></div>
    <i
        style="cursor: pointer;"
        (click)="onCancel()"
        aria-label="Close modal">
        <img src="assets/images/icons/titan/titan-close.svg" alt="Close" width="16" height="16">
    </i>
  </div>
  <div class="d-flex flex-column" style="gap:32px">
    <div class="d-flex flex-column align-items-center" style="gap: 16px">
      <h5>{{ title }}</h5>
      <div [innerHTML]="textContent" style="text-align:center; white-space: pre-line"></div>
    </div>
    <div class="d-flex justify-content-center gap-16">
      <app-titan-button
        [variant]="'primary'"
        (onPress)="onConfirm()">
        <ng-container children>
          <div>Confirm</div>
        </ng-container>
      </app-titan-button>
      <app-titan-button [variant]="'secondary'" (onPress)="onCancel()">
        <ng-container children>
          <div>Cancel</div>
        </ng-container>
      </app-titan-button>
    </div>
  </div>
</div>
